import styled from 'styled-components';
import { FontWeightTypes } from '../elements.types';

const Weighted = styled.span<{ $fontWeight: FontWeightTypes }>`
  font-weight: ${(props) => props.$fontWeight};
`;

export default Weighted;
